/**
 * Seal Subscriptions — selección estable + selling_plan en add-to-cart AJAX.
 * Persiste la intención de suscripción al cambiar la frecuencia de entrega.
 */
(function () {
  if (window.__pilotSealProduct) return;
  window.__pilotSealProduct = true;

  var reinforceTimer = null;

  function stateHost(form) {
    return form && (form.closest('.product-info') || form);
  }

  function mainForm() {
    return document.querySelector('.product-info .product-info__purchase-form form')
      || document.querySelector('.product-info__seal-in-form')?.closest('form');
  }

  function sealRoot(form) {
    return form?.querySelector('.product-info__seal-in-form')
      || form?.querySelector('.sealsubs-container')?.closest('.product-info__block-item, .product-info__purchase-stack');
  }

  function isFrequencyControl(target) {
    return !!target.closest(
      '.sls-select-container, .sls-selling-plan-group-options, select.sls-select, option, .sls-more-info-container, .sls-widget-branding'
    );
  }

  function planIdForForm(form) {
    var select = form.querySelector('.product-info__seal-in-form select.sls-select')
      || form.querySelector('.sealsubs-container select.sls-select');
    return select && select.value ? select.value : '';
  }

  function ensureSellingPlanInput(form) {
    var input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.value = '';
      form.appendChild(input);
    }
    return input;
  }

  function setSellingPlan(form, planId) {
    ensureSellingPlanInput(form).value = planId || '';
    form.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
      input.value = planId || '';
    });
  }

  function persistIntent(form, type, planId) {
    var host = stateHost(form);
    if (!host) return;
    host.dataset.pilotSealMode = type;
    host.dataset.pilotSealPlan = type === 'subscription' ? (planId || planIdForForm(form) || '') : '';
  }

  function readIntent(form) {
    var host = stateHost(form);
    if (!host) return { type: '', planId: '' };
    return {
      type: host.dataset.pilotSealMode || '',
      planId: host.dataset.pilotSealPlan || ''
    };
  }

  function updateSealUi(form, type) {
    var root = sealRoot(form);
    if (!root) return;

    root.querySelectorAll('.sls-option-container').forEach(function (container) {
      container.style.setProperty('display', 'table', 'important');
      var isSubscription = !!container.querySelector('.sls-option[data-type="subscription"]');
      var isActive = (type === 'subscription' && isSubscription) || (type === 'one_time' && !isSubscription);
      container.classList.toggle('sls-active', isActive);

      var radioUi = container.querySelector('[role="radio"]');
      if (radioUi) {
        radioUi.setAttribute('aria-checked', isActive ? 'true' : 'false');
      }
    });
  }

  function stopReinforce() {
    if (reinforceTimer) {
      clearInterval(reinforceTimer);
      reinforceTimer = null;
    }
  }

  function selectSealOption(form, type, planId) {
    if (!form) return;

    var oneTime = form.querySelector('.sls-option[data-type="one_time"]');
    var subscription = form.querySelector('.sls-option[data-type="subscription"]');
    if (!oneTime || !subscription) return;

    var resolvedPlan = planId || planIdForForm(form);

    if (type === 'subscription') {
      oneTime.checked = false;
      subscription.checked = true;
      setSellingPlan(form, resolvedPlan);
      persistIntent(form, 'subscription', resolvedPlan);
    } else {
      subscription.checked = false;
      oneTime.checked = true;
      setSellingPlan(form, '');
      persistIntent(form, 'one_time', '');
    }

    updateSealUi(form, type);
  }

  function applyPersistedIntent(form) {
    if (!form) return;
    var intent = readIntent(form);
    if (intent.type !== 'subscription') return;

    var planId = intent.planId || planIdForForm(form);
    selectSealOption(form, 'subscription', planId);
  }

  function reinforceSelection(form, type, planId) {
    stopReinforce();
    var ticks = 0;
    reinforceTimer = setInterval(function () {
      selectSealOption(form, type, planId);
      ticks += 1;
      if (ticks >= 8) {
        stopReinforce();
      }
    }, 60);
  }

  function handleFrequencyChange(form, select) {
    stopReinforce();
    var planId = select.value;
    persistIntent(form, 'subscription', planId);
    selectSealOption(form, 'subscription', planId);
  }

  function handleSealPointer(event) {
    if (isFrequencyControl(event.target)) return;

    var container = event.target.closest('.sls-option-container');
    if (!container) return;

    var root = container.closest('.product-info__seal-in-form, .sealsubs-container');
    if (!root) return;

    var form = container.closest('form');
    if (!form) return;

    if (event.target.closest('.sls-selling-plan-group-options')) return;

    var type = container.querySelector('.sls-option[data-type="subscription"]') ? 'subscription' : 'one_time';

    event.preventDefault();
    event.stopPropagation();

    selectSealOption(form, type);
    if (type === 'subscription') {
      reinforceSelection(form, type);
    } else {
      stopReinforce();
    }
  }

  function watchSealVisibility() {
    document.querySelectorAll('.product-info__seal-in-form, .product-info__purchase-form').forEach(function (root) {
      if (root.dataset.pilotSealWatch === 'true') return;
      root.dataset.pilotSealWatch = 'true';

      var restoreTimer = null;
      var observer = new MutationObserver(function () {
        var form = mainForm();
        if (!form) return;

        root.querySelectorAll('.sls-option-container').forEach(function (container) {
          if (getComputedStyle(container).display === 'none') {
            container.style.setProperty('display', 'table', 'important');
          }
        });

        clearTimeout(restoreTimer);
        restoreTimer = setTimeout(function () {
          applyPersistedIntent(form);
        }, 20);
      });

      observer.observe(root, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        subtree: true,
        childList: true
      });
    });
  }

  function bindForm(form) {
    if (!form || form.dataset.pilotSealBound === 'true') return;
    form.dataset.pilotSealBound = 'true';

    ensureSellingPlanInput(form);

    form.addEventListener('submit', function () {
      var intent = readIntent(form);
      if (intent.type === 'subscription' || form.querySelector('.sls-option[data-type="subscription"]:checked')) {
        setSellingPlan(form, intent.planId || planIdForForm(form));
      }
    }, true);

    form.addEventListener('change', function (event) {
      if (!event.target.closest('.product-info__seal-in-form, .sealsubs-container')) return;

      if (event.target.matches('select.sls-select')) {
        handleFrequencyChange(form, event.target);
        return;
      }

      if (event.target.matches('.sls-option[data-type="subscription"]') && event.target.checked) {
        selectSealOption(form, 'subscription');
        return;
      }

      if (event.target.matches('.sls-option[data-type="one_time"]') && event.target.checked) {
        stopReinforce();
        selectSealOption(form, 'one_time');
      }
    });

    form.addEventListener('input', function (event) {
      if (event.target.matches('select.sls-select')) {
        handleFrequencyChange(form, event.target);
      }
    });

    form.addEventListener('focusin', function (event) {
      if (event.target.matches('select.sls-select')) {
        stopReinforce();
        persistIntent(form, 'subscription', event.target.value);
      }
    });
  }

  function bindSealClicks() {
    if (document.body.dataset.pilotSealClicksBound === 'true') return;
    document.body.dataset.pilotSealClicksBound = 'true';

    document.addEventListener('pointerdown', handleSealPointer, true);
    document.addEventListener('click', handleSealPointer, true);
  }

  function init() {
    bindSealClicks();
    var form = mainForm();
    bindForm(form);
    watchSealVisibility();
    applyPersistedIntent(form);
  }

  function onRerender() {
    document.querySelectorAll('.product-info__purchase-form form').forEach(function (form) {
      form.dataset.pilotSealBound = '';
      form.closest('.product-info__purchase-form')?.removeAttribute('data-pilot-seal-watch');
    });
    document.querySelectorAll('[data-pilot-seal-watch]').forEach(function (el) {
      el.removeAttribute('data-pilot-seal-watch');
    });
    setTimeout(init, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    [300, 900, 2000, 4000].forEach(function (ms) {
      setTimeout(init, ms);
    });
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 200);
  });

  document.addEventListener('product:rerender', onRerender);
})();
